#import "../fragments/external-meeting-for-modal-fragment.graphql"

mutation ExternalMeetingRecordingDelete($input: ExternalMeetingRecordingDeleteInput!) {
    externalMeetingRecordingDelete(input: $input) {
        externalMeeting {
            ...ExternalMeetingForModalFragment
        }
    }
}
